import { useRouter } from 'next/router';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { useAuthStore } from '../store/AuthStore';
import { Routes } from '../util/routes';

type Props = {
  label: string;
  className?: string;
};

export const CommunityRegisterButton = ({ label, className }: Props) => {
  const router = useRouter();
  const { loginWithRedirect } = useAuth0();
  const { user, userRoles } = useAuthStore(({ state }) => state);

  const classname = clsx('mx-auto mt-10', className);

  if (!user || !userRoles?.includes('community-user')) {
    return (
      <Button
        className={classname}
        onClick={() =>
          loginWithRedirect({
            appState: {
              returnTo:
                window.location.origin +
                Routes.registerCommunity(router.asPath),
            },
            authorizationParams: {
              screen_hint: 'signup',
            },
          })
        }
      >
        <span className="px-6">{label}</span>
      </Button>
    );
  }

  return null;
};
